class UserNotifications {

  constructor () {

    this.lastSeenId = null;
    this.latestNotifications = [];
    this.updateTimeout = null;

  }

  updateBadges() {

    clearTimeout(this.updateTimeout);

    this.updateTimeout = setTimeout(() => {

      const count = this.getUnseenCount();

      let countBadges = document.querySelectorAll('.badge-notifications-count');

      if(countBadges) {

        countBadges = Array.from(countBadges);

        countBadges.forEach(badge => {
          if(count > 0) {
            badge.classList.add('has-notifications');
          } else {
            badge.classList.add('has-no-notifications');
          }

          if(count > 9) {
            badge.innerHTML = '9+';
          } else {
            badge.innerHTML = count;
          }

        });

      }

    }, 100);

  }

  getUnseenCount() {

    let unseenCount = 0;

    if(this.latestNotifications && this.latestNotifications.length > 0) {

      const lastSeenId = this.getLastSeenId();

      // set unseen count
      this.latestNotifications.forEach(notification => {
        const id = parseInt(notification.id);

        if(id > lastSeenId) {
          unseenCount++;
        }
      });

    }

    return unseenCount;

  }

  getLastSeenId() {

    if(this.lastSeenId === null) {

      let savedId = null;

      if(window.currentUser && window.currentUser.id) {
        savedId = localStorage.getItem(`${window.currentUser.id}.lastNotificationId`);
        savedId = parseInt(savedId);
      }

      if(!savedId) {
        if(this.latestNotifications && this.latestNotifications.length > 0) {
          this.lastSeenId = parseInt(this.latestNotifications[0].id);
          this.saveLastSeenId(this.lastSeenId);
        }
      } else {
        this.lastSeenId = parseInt(savedId);
      }

    }

    return this.lastSeenId;

  }

  saveLastSeenId(id) {

    if(id && window.currentUser && window.currentUser.id) {

      id = parseInt(id);
      this.lastSeenId = id;

      localStorage.setItem(`${window.currentUser.id}.lastNotificationId`, id);

      this.updateBadges();

    }

  }

  getNotifications() {

    return new Promise((resolve, reject) => {

      window.apiRequest('get', '/user/notifications').then(r => {

        if(r.type === 'success') {

          this.latestNotifications = r.data.items;

          resolve();

        }

      });

    });

  }

}

const UserNotificationsInstance = new UserNotifications();

export default UserNotificationsInstance;
